import React, { useEffect } from "react";
import Modal from "react-modal";
// import { Api } from "../../services/api";
import {
  Body,
  Button,
  ButtonContainer,
  Container,
  Header,
} from "./ConfirmationModal.styles";

import { ConfirmationModalProps } from "./ConfirmationModal.types";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    borderRadius: "6px",
  },
  overlay: {
    zIndex: 10,
    backgroundColor: "rgba(192, 192, 192, 0.4)",
  },
};

Modal.setAppElement("#root");

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  // rowData,
  modalIsOpen,
  toggleConfirmationModal,
}) => {
  const [isOpen, setIsOpen] = React.useState(modalIsOpen);
  // const teamId = rowData.id;

  useEffect(() => {
    setIsOpen(modalIsOpen);
  }, [modalIsOpen]);

  const closeModal = () => {
    toggleConfirmationModal(false);
  };

  const deleteItem = () => {
    //   try {
    //     const response = await Api.teams.delete(teamId);
    //   } catch (error) {
    //     console.log("Members fetch:", error);
    //   }
    // };
  };

  return (
    <Container>
      <Modal isOpen={isOpen} style={customStyles}>
        <Header>Are you sure you want to delete?</Header>
        <Body>This can not be undone.</Body>
        <ButtonContainer>
          <Button onClick={deleteItem} primary>
            Yes, delete
          </Button>
          <Button onClick={closeModal}>Cancel</Button>
        </ButtonContainer>
      </Modal>
    </Container>
  );
};
